import { type InferOutput, number, object, string } from 'valibot';

export interface StravaAthlete {
  id: number;
  firstName: string;
  lastName: string;
  profilePictureMedium: string;
}

export const StravaAthleteSchema = object({
  id: number(),
  firstName: string(),
  lastName: string(),
  profilePictureMedium: string(),
});

export type StravaAthleteType = InferOutput<typeof StravaAthleteSchema>;

export interface StravaDetailedPhoto {
  unique_id: string;
  default_photo: boolean;
  urls: {
    2048: string;
  };
}
